module.exports = __webpack_public_path__ + "img/onepagePhone.c06844cc.png";